import { Loader2, GripVertical } from "lucide-react";

export const CroppedVideoPreview = ({
  canvasRef,
  videoRef,
  videoStreamUrl,
  selectedAspectRatio,
  cropPos,
  currentScene,
  sceneCount,
  visibleGraphics,
  selectedGraphic,
  dragging,
  playing,
  onPlay,
  onPause,
  onDragStart,
  onSelectGraphic,
  onDurationLoaded,
}) => {
  return (
    <div className="flex justify-center">
      <div
        ref={canvasRef}
        className={`relative overflow-hidden rounded-sm border border-cyan-500/15 bg-black ${
          dragging ? "cursor-grabbing" : ""
        }`}
        style={{
          aspectRatio: selectedAspectRatio
            ? selectedAspectRatio.replace(":", "/")
            : "16/9",
          maxHeight: "60vh",
          width: "100%",
          maxWidth: (() => {
            if (!selectedAspectRatio) return "100%";
            const [w, h] = selectedAspectRatio.split(":").map(Number);
            if (h > w) return `${Math.round((w / h) * 60)}vh`;
            return "100%";
          })(),
        }}
        data-testid="video-canvas"
      >
        {videoStreamUrl ? (
          <>
            <video
              ref={videoRef}
              src={videoStreamUrl}
              className="absolute inset-0 w-full h-full"
              style={{
                objectFit: "cover",
                objectPosition: `${cropPos.x}% ${cropPos.y}%`,
              }}
              playsInline
              onPlay={onPlay}
              onPause={onPause}
              onLoadedMetadata={() => {
                if (videoRef.current) onDurationLoaded(videoRef.current.duration);
              }}
              data-testid="restripe-video-player"
            />
            <div className="absolute top-3 left-3 bg-[#020a14]/80 px-2.5 py-1 rounded-sm text-xs text-cyan-200/60 font-mono z-10">
              {selectedAspectRatio}
            </div>
            <div className="absolute top-3 right-3 bg-[#020a14]/80 px-2.5 py-1 rounded-sm text-xs text-cyan-200/60 z-10">
              Scene {currentScene + 1} / {sceneCount}
            </div>
            {visibleGraphics.map((g) => (
              <div
                key={g.id}
                onMouseDown={(e) => onDragStart(e, g)}
                onClick={(e) => {
                  e.stopPropagation();
                  onSelectGraphic(g);
                }}
                className={`absolute select-none transition-shadow z-10 ${
                  dragging?.id === g.id ? "cursor-grabbing z-20" : "cursor-grab"
                } ${
                  selectedGraphic?.id === g.id
                    ? "ring-1 ring-cyan-400 ring-offset-1 ring-offset-transparent"
                    : "hover:ring-1 hover:ring-cyan-500/40"
                }`}
                style={{
                  left: `${g.position?.x ?? 50}%`,
                  top: `${g.position?.y ?? 50}%`,
                  transform: "translate(-50%, -50%)",
                }}
                data-testid={`graphic-preview-${g.id}`}
              >
                {g.content && (
                  <div className="px-4 py-2 bg-black/70 border border-cyan-500/30 text-sm text-white rounded-sm whitespace-nowrap flex items-center gap-2">
                    <GripVertical className="w-3 h-3 text-cyan-400/30 shrink-0" />
                    <span>{g.content}</span>
                  </div>
                )}
              </div>
            ))}
            {visibleGraphics.length > 0 && !dragging && (
              <div className="absolute bottom-2 left-1/2 -translate-x-1/2 text-[10px] text-cyan-200/20 bg-black/40 px-2 py-0.5 rounded pointer-events-none z-10">
                Drag overlays to reposition
              </div>
            )}
          </>
        ) : (
          <div className="absolute inset-0 flex items-center justify-center text-cyan-500/20">
            <Loader2 className="w-8 h-8 animate-spin" />
          </div>
        )}
      </div>
    </div>
  );
};
